/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Words_DraftInputs */

const en_us2_search_words_draft = /** @type {(inputs: Search_Words_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`draft plan new review changes`)
};

const pt_br2_search_words_draft = /** @type {(inputs: Search_Words_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rascunho plano novo revisar mudancas`)
};

const es_419_search_words_draft = /** @type {(inputs: Search_Words_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`borrador plan nuevo revisar cambios`)
};

const pt_pt2_search_words_draft = /** @type {(inputs: Search_Words_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rascunho plano novo rever alteracoes mudancas`)
};

const fr_fr2_search_words_draft = /** @type {(inputs: Search_Words_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`brouillon programme nouveau revoir changements`)
};

const de_de2_search_words_draft = /** @type {(inputs: Search_Words_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`entwurf plan neu prüfen änderungen`)
};

const it_it2_search_words_draft = /** @type {(inputs: Search_Words_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bozza scheda piano nuovo rivedi modifiche`)
};

/**
* | output |
* | --- |
* | "draft plan new review changes" |
*
* @param {Search_Words_DraftInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_words_draft = /** @type {((inputs?: Search_Words_DraftInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Words_DraftInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_words_draft(inputs)
	if (locale === "es-419") return es_419_search_words_draft(inputs)
	if (locale === "pt-PT") return pt_pt2_search_words_draft(inputs)
	if (locale === "fr-FR") return fr_fr2_search_words_draft(inputs)
	if (locale === "de-DE") return de_de2_search_words_draft(inputs)
	if (locale === "it-IT") return it_it2_search_words_draft(inputs)
	return en_us2_search_words_draft(inputs)
});
export { search_words_draft as "search.words_draft" }